import app from "./app"
import user from "./user"
import permission from "./permission"
import common from "./common"
export default {
    app,
    user,
    permission,
    common
}
